import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import * as Sentry from "@sentry/vue";


/**
 * Bootstrap - note - have left off JS & JQuery deliberately
 */
import 'bootstrap/dist/css/bootstrap.css'

/**
 * This CSS file is loaded here, as if it's loaded in the Vue components, the buttons on the editor don't work. Might
 * be related to it then needing to be loaded twice?
 */
import "summernote/dist/summernote-bs4.min.css"


/**
 * $http library
 */
import api from './api'
Vue.prototype.$http = api;


/**
 * Vee-Validate
 */
import { setInteractionMode, extend } from 'vee-validate'
import { required, email, is, min, max, numeric, regex, double } from 'vee-validate/dist/rules'
setInteractionMode('eager');
extend('required', {
  ...required,
  message: 'This field is required'
});
extend('min', {
  ...min,
  message: 'This field is not long enough.'
});
extend('max', {
  ...max,
  message: 'This field is too long'
});
extend('email', {
  ...email,
  message: 'Please enter a valid email address'
});
extend('is', {
  ...is,
  message: 'This field is required'
});
extend('numeric', {
  ...numeric,
  message: 'Please enter numbers only'
});
extend('double', {
  ...double,
  message: 'Please enter a number with max 2 decimal places'
});
extend('regex', {
  ...regex,
  message: 'Please check the format of this field'
});
extend('confirm', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match'
});
extend('differs', {
  params: ['target'],
  validate(value, { target }) {
    return value !== target;
  },
  message: 'The new password must be different to the old one'
});


/**
 * Shepherd
 */
import VueShepherd from 'vue-shepherd';
Vue.use(VueShepherd);


/**
 * Markdown
 *
 */
import marked from 'marked';
import helpers from 'marked/src/helpers'

// Overrides of Markdown default behavior to render links opening in new tabs
marked.Renderer.prototype.link = function(href, title, text) {
  href = helpers.cleanUrl(this.options.sanitize, this.options.baseUrl, href);
  if (href === null) {
    return text;
  }
  let out = '<a target="_blank" href="' + helpers.escape(href) + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};
Vue.filter("marked", marked);


/**
 * Modal close on click outside
 *
 * Taken from: https://stackoverflow.com/questions/36170425/detect-click-outside-element
 */
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});


/**
 * Configure Sentry
 */
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", process.env.VUE_APP_API_BASE_URL],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  environment: process.env.NODE_ENV,
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysSessionSampleRate: process.env.VUE_APP_SENTRY_SESSION_SAMPLE_RATE,
  // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  replaysOnErrorSampleRate: 1.0,
});


Vue.config.productionTip = false

/*
 * Instantiate Vue / the app
 *
 */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');


/**
 * Prototype extensions
 * @param el
 * @param compareFn
 * @returns {number}
 */
Array.prototype.pushSorted = function (el, compareFn) {
  this.splice((function (arr) {
    let m = 0;
    let n = arr.length - 1;

    while (m <= n) {
      let k = (n + m) >> 1;
      let cmp = compareFn(el, arr[k]);

      if (cmp > 0) m = k + 1;
      else if (cmp < 0) n = k - 1;
      else return k
    }

    return -m - 1
  })(this), 0, el);

  return this.length
};

Array.prototype.replaceSorted = function(el, compareFn) {
  this.splice((function (arr) {
    let m = 0;
    let n = arr.length - 1;

    while (m <= n) {
      let k = (n + m) >> 1;
      let cmp = compareFn(el, arr[k]);

      if (cmp > 0) m = k + 1;
      else if (cmp < 0) n = k - 1;
      else return k
    }

    return -m - 1
  })(this), 1, el);

  return this.length
};

String.prototype.hashCode = function() {
  var hash = 0, i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
